'use strict';

angular
	.module('PinMeTo.services')
	.service('pmtSideBarCollapsedService', function ($window, localStorageService) {
		const service = this;

		function get() {
			return !!localStorageService.get('sidebarCollapsed');
		}

		function set(collapsed) {
			localStorageService.set('sidebarCollapsed', collapsed);
		}

		service.get = get;
		service.set = set;
	});
